import { url } from "../../Helpers/utils/Constant";
import { HttpClient } from "../../rest/utils/http";

export const addOwner = `${url}/api/atab/member-company/member/owner`;
export const AddCompanyOwnerMutation = async (data: any) => {
  return await HttpClient.post(addOwner, data);
};
